export default "__VITE_ASSET__b01bee18__"